import { z } from 'zod';

/**
 * Body de `POST /api/v1/proyectos/:id/participantes-privados`.
 * Espeja `AssignParticipantePrivadoDto` del backend (`usuarioId: number`).
 */
export const asignarParticipantePrivadoSchema = z.object({
  usuarioId: z.coerce.number().int().positive('Seleccione un participante de la lista.'),
});

/**
 * Query de `GET /api/v1/proyectos/usuarios-disponibles?rol=ParticipantePrivado`.
 * El endpoint unificado decide por `rol` el pool de candidatos; este schema fija
 * `rol = 'ParticipantePrivado'` y solo expone los filtros aplicables. Cuando
 * `proyectoId` viene definido, el backend excluye los ya asignados.
 */
export const filtrosParticipantesPrivadosDisponiblesSchema = z.object({
  page: z.coerce.number().int().min(1).optional(),
  limit: z.coerce.number().int().min(1).max(100).optional(),
  search: z.string().trim().optional(),
  proyectoId: z.coerce.number().int().positive().optional(),
});

export type AsignarParticipantePrivadoInput = z.infer<typeof asignarParticipantePrivadoSchema>;
export type FiltrosParticipantesPrivadosDisponiblesInput = z.infer<
  typeof filtrosParticipantesPrivadosDisponiblesSchema
>;
